
import { Component, Vue } from "vue-property-decorator";
import auth from "@/store/user/module/auth";
import { LoginRequest } from "@/store/user/model/user";
import common from "@/store/common/module/common";

@Component
export default class Login extends Vue {
  user = { countryCode: 91 } as LoginRequest;

  get loading(): boolean {
    return common.loading;
  }

  get error(): string {
    return common.error;
  }

  processEmailPhone() {
    if (this.user.emailPhone) {
      if (isNaN(parseInt(this.user.emailPhone))) {
        this.user.email = this.user.emailPhone;
        this.user.phone = null;
      } else {
        this.user.phone = parseInt(this.user.emailPhone);
        this.user.email = null;
        if (this.user.countryCode == null) {
          common.setError("Please provide country code");
          return false;
        }
      }
      return true;
    }
    common.setError("Please enter email/phone");
    return false;
  }

  login() {
    if (!this.processEmailPhone()) return;
    common.setLoading(true);
    auth
      .login(this.user)
      .then(() => {
        common.setLoading(false);
      })
      .catch(() => {
        common.setLoading(false);
      });
  }

  onDismissed() {
    //this.$store.dispatch("clearError");
  }

  async beforeMount() {
    try {
      await auth.doPreLogin();
    } catch (e) {
      console.log(e);
    }
  }

  mounted() {
    if (auth.authContent) {
      this.user.countryCode = auth.authContent.countryCode;
    }
  }
}
